import { useJsApiLoader } from '@react-google-maps/api';
import env from '@trashlab/sitesapp/src/env';
import { useMemo } from 'react';

// Define static libraries array to prevent recreation on each render
const GOOGLE_MAPS_LIBRARIES: ('places' | 'geometry')[] = ['places', 'geometry'];

export const useGoogleMapsLoader = () => {
  const options = useMemo(
    () => ({
      id: 'google-map-script',
      googleMapsApiKey: env.NEXT_PUBLIC_GOOGLE_MAPS_API_KEY ?? '',
      libraries: GOOGLE_MAPS_LIBRARIES,
      version: 'weekly',
      language: 'en',
      region: 'US',
    }),
    [], // Empty dependency array since all values are static
  );

  return useJsApiLoader(options);
};
